import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

interface MemberCellProps {
  name: string;
  subtitle?: string;
  imageUrl?: string;
}

const getInitials = (name: string): string =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

/**
 * Single reusable member identity cell (avatar + name + optional subtitle).
 * Used across the vacation approvals view — pending requests and team usage.
 */
export const MemberCell: React.FC<MemberCellProps> = ({ name, subtitle, imageUrl }) => (
  <div className="flex items-center gap-3">
    <Avatar className="h-9 w-9">
      {imageUrl && <AvatarImage src={imageUrl} alt={name} />}
      <AvatarFallback className="bg-primary/10 text-primary text-xs">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
    <div className="min-w-0">
      <p className="truncate text-sm font-medium text-foreground">{name}</p>
      {subtitle && <p className="truncate text-xs text-muted-foreground">{subtitle}</p>}
    </div>
  </div>
);
